import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useEnrichmentApi } from "@/v2/entities/enrichment/Enrichment.api";
import EnrichmentCreationForm from "@/v2/features/enrichment/EnrichmentCreationForm";
import type { EnrichmentType } from "@/v2/features/enrichment/EnrichmentCreationForm";

interface EnrichmentCreateInput {
  task: string;
  name: string;
  type: EnrichmentType;
  apiResponse: any;
}

export default function CreateEnrichmentPage() {
  const navigate = useNavigate();
  const enrichmentApi = useEnrichmentApi();
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (data: EnrichmentCreateInput) => {
      setLoading(true);

      try {
        await enrichmentApi.create({
          name: data.name,
          task: data.task,
          filterRules: "{}",
          options: JSON.stringify(data.apiResponse.options || []),
          isEnabled: false, // Start disabled by default
          trigger: data.apiResponse.trigger || "ON_FINITE_STATE",
          output: JSON.stringify(data.apiResponse.output || []),
          sources: data.apiResponse.sources || [],
          topicIds: [],
          ticketSystemSyncEnabled: false,
          ticketSystemSyncMappings: { mappings: [] },
        });

        toast("enrichment created successfully");
        navigate("/enrichments");
      } catch (err: any) {
        toast.error("Failed to create enrichment");
      } finally {
        setLoading(false);
      }
    },
    [enrichmentApi, navigate]
  );

  const handleCancel = useCallback(() => {
    navigate("/enrichments");
  }, [navigate]);

  return (
    <EnrichmentCreationForm
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      loading={loading}
    />
  );
}
